import React from 'react'

import './myAccount.css'

/**
 * Shared My Account page header (mock `.ac-head`): display-font title, 13px muted subtitle,
 * right-side actions pushed with margin-left:auto (full width below 600px).
 */
export default function AccountPageHeader({ title, subtitle, children, className = '' }) {
    return (
        <header className={`ac-head ${className}`.trim()}>
            <div className="min-w-0">
                <h1>{title}</h1>
                {subtitle ? <p>{subtitle}</p> : null}
            </div>
            {children ? <div className="ac-head-right">{children}</div> : null}
        </header>
    )
}
